import { CURRENCY_COOKIE_NAME } from "@/config/constConf";
import { getCookieItem } from "@/lib/commonService";
import { useCallback } from "react";
import { useProductDetailsContext } from "../provider";
import { productDetailBrowse } from "../utils";

export default function useBrowserGoodsDetailGA() {
    const [productDetail, activeObj] = useProductDetailsContext((state) => [
        state.productDetail,
        state.activeObj,
    ]);

    const browserGoodsDetailGA = useCallback(() => {
        productDetailBrowse({
            currency: getCookieItem(CURRENCY_COOKIE_NAME),
            value: activeObj?.onsale?.price,
            items: [
                {
                    id: productDetail.products_id,
                    name: productDetail.products_model,
                    item_id: productDetail.products_id,
                    item_name: productDetail.products_model,
                },
            ],
        });
    }, [
        activeObj?.onsale?.price,
        productDetail.products_id,
        productDetail.products_model,
    ]);
    return browserGoodsDetailGA;
}
